import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  BooleanField,
  EditButton,
  FunctionField,
  Filter,
  SelectInput,
  ReferenceInput,
  useListContext,
} from 'react-admin';
import { PERMISSIONS } from '../../constants';
import ListPagination from '../../components/ListPagination';
import Permission from '../../components/Permission';
import { getChainId } from '../../lib';

const iconNameChoices = [
  { id: 'default', name: 'Padrão' },
  { id: 'pro', name: 'Pro' },
  { id: 'gold', name: 'Gold' },
  { id: 'vip', name: 'VIP' },
];

const PlanFilter = () => {
  const { filterValues } = useListContext();
  return (
    <Filter>
      <SelectInput
        label="Status"
        source="isEnabled"
        choices={[{ label: 'Ativos', value: true }, { label: 'Inativos', value: false }]}
        optionText="label"
        optionValue="value"
        emptyText="Todos"
      />
      {Permission({
        permission: PERMISSIONS.ADMIN,
        children: (
          <ReferenceInput
            reference="chains"
            source="chainId"
            style={{ minWidth: 220 }}
            defaultValue={getChainId()}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={9999}
          >
            <SelectInput label="Rede" optionText="name" />
          </ReferenceInput>
        ),
      })}
    </Filter>
  );
};

const PlanList = (props: any) => {
  const chainId = getChainId();

  const filterDefaultValues: any = { isEnabled: true };
  if (chainId) {
    filterDefaultValues.chainId = chainId;
  }

  return (
    <Permission permission={PERMISSIONS.PLAN}>
      <List
        {...props}
        title="Planos"
        sort={{ field: 'createdAt', order: 'DESC' }}
        filterDefaultValues={filterDefaultValues}
        filters={<PlanFilter />}
        exporter={false}
        pagination={<ListPagination />}
        perPage={25}
      >
        <Datagrid bulkActionButtons={false} rowClick="edit">
          <TextField source="identify" label="Código" />
          <TextField source="name" label="Nome" />
          <FunctionField
            label="Ícone"
            render={(record: any) =>
              record ? iconNameChoices.find(ic => ic.id === record.iconName)?.name || record.iconName : '--'
            }
          />
          <NumberField source="priority" label="Prioridade" />
          <NumberField source="durationDays" label="Duração (dias)" />
          <FunctionField
            render={(record: any) => (record && record.isEnabled ? 'Ativo' : 'Inativo')}
            label="Status"
            textAlign="center"
          />
          <DateField source="createdAt" label="Criado em" showTime locales="pt-BR" />
          <EditButton />
        </Datagrid>
      </List>
    </Permission>
  );
};

export default PlanList;
